import Layout from '../layout/Layout'
import SEO from '../components/SEO/SEO'
import PartnersAccordian from '../components/PartnersAccordian/PartnersAccordian'
import { partnerCompanyInfo } from '../components/PartnersAccordian/consts'

const Partners = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="h-full w-full object-cover"
                  src="dfwSkyline.png"
                  alt="Dallas-Fort Worth skyline"
                />
              </div>
              <div className="relative px-4 py-16 md:py-16 lg:py-32 max-w-screen-xl mx-auto">
                <h1 className="text-3xl md:text-5xl tracking-tight text-darkBlue">
                  Partners{' '}
                  <span className="text-globeGreen">you can trust</span>
                </h1>
                <p className="mt-6 max-w-lg text-xl text-grey sm:max-w-3xl">
                  The following programs are available to Evry members who meet
                  the relevant clinical acceptance criteria. These services are
                  paid for entirely by Evry Health as part of a broader effort
                  to improve the health and wellness of our membership.
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="max-w-screen-xl mx-auto py-8 md:py-24">
          {partnerCompanyInfo.map((item, index) => {
            return (
              <PartnersAccordian
                key={index}
                companyLogo={item.companyLogo}
                companyLogoAltText={item.companyLogoAltText}
                companySummary={item.companySummary}
                statistics={item.statistics}
              />
            )
          })}
        </section>
      </Layout>
    </>
  )
}

export default Partners
